import type { CurrencyISO } from '@/constants/currencies';
import { isCurrencyISO } from '@/constants/currencies';

type CurrencyInfo = {
  reporting_currency_iso: CurrencyISO;
  reporting_unit_text: string;
  reporting_unit: number;
};

export const isCurrencyInfo = (
  currencyInfo: unknown
): currencyInfo is CurrencyInfo => {
  return (
    typeof currencyInfo === 'object' &&
    currencyInfo !== null &&
    'reporting_currency_iso' in currencyInfo &&
    'reporting_unit_text' in currencyInfo &&
    isCurrencyISO(currencyInfo.reporting_currency_iso)
  );
};
